import {
	TLoyaltySettings,
	TLoyaltySettingsFormValues,
} from '@modules/LoyaltyProgramme/types';
import { ApiRequest } from '@zeal/zeal-lib';
import { ENDPOINTS } from '../endpoints';

export async function freemiumLoyaltySettings() {
	return new ApiRequest(ENDPOINTS.loyaltyProgramme.settings)
		.addHeader('Accept', 'application/json')
		.GET<ApiResponse<TLoyaltySettings>>()
		.then((payload) => payload);
}

export async function createLoyaltySettings(
	payload: TLoyaltySettingsFormValues
) {
	return new ApiRequest(ENDPOINTS.loyaltyProgramme.createSettings)
		.addHeader('Accept', 'application/json')
		.addHeader('Content-Type', 'application/json')
		.POST<ApiResponse<TLoyaltySettings>>(JSON.stringify(payload))
		.then((payload) => payload);
}
